module.exports = __webpack_public_path__ + "static/media/kelbox.c149fdef.PNG";